import { importFileStatus } from '@modules/councilUnits/constants';

import type { CampImportItem } from './types';

export const ACCEPT_VENDOR_TYPES = '.txt';
export const ACCEPT_CAMP_TYPES = '.csv';

/** In bytes (300 KB) */
export const CAMP_MAX_FILE_SIZE = 300 * 1024;

/** Display order of the camp import toggles and of the note's "attached to" list */
export const CAMP_IMPORT_ITEMS: readonly {
  name: CampImportItem;
  labelId: string;
}[] = [
  {
    name: 'meritBadgeRequirements',
    labelId: 'advancementImport.camp.setup.item.requirements',
  },
  {
    name: 'completeMeritBadges',
    labelId: 'advancementImport.camp.setup.item.completeMeritBadges',
  },
  {
    name: 'leaderApproveMeritBadges',
    labelId: 'advancementImport.camp.setup.item.leaderApprove',
  },
];

/** Placeholder: the API hasn't published a limit for `comment` */
export const CAMP_NOTE_MAX_LENGTH = 250;

/** Statuses after which nothing else happens server-side (stop polling). */
const TERMINAL_STATUSES: readonly string[] = [
  importFileStatus.PROCESSING_DONE,
  importFileStatus.ERROR_UPLOAD,
  importFileStatus.ERROR_PROCESSING_DONE,
];

/** Statuses that represent a failed import. */
const ERROR_STATUSES: readonly string[] = [
  importFileStatus.ERROR_UPLOAD,
  importFileStatus.ERROR_PROCESSING_DONE,
];

export const isCampTerminal = (status?: string): boolean =>
  !!status && TERMINAL_STATUSES.includes(status);

export const isCampError = (status?: string): boolean =>
  !!status && ERROR_STATUSES.includes(status);
